import { OmniSearch } from './OmniSearch';

export default OmniSearch;
